import { jsx as _jsx } from "react/jsx-runtime";
import HighlightText from '../HighlightText';
export const Cell = (props)=>{
    const { text, filter, ...rest } = props;
    return /*#__PURE__*/ _jsx("td", {
        ...rest,
        children: /*#__PURE__*/ _jsx(HighlightText, {
            text: text?.toString(),
            search: filter
        })
    });
};
